import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: "[InputMaxLengthValidate]",
})
// tslint:disable-next-line:directive-class-suffix
export class InputMaxLengthValidate {
  @Input('InputMaxLengthValidate') num: any;

  @HostListener("keypress", ["$event"])
  onkeypress(event: any): boolean {
    if(event && event.target.value.toString().length == this.num) {
      event.stopPropagation();
      return false;
    }
  }
}
